<template>
  <div class="container">
    <Header></Header>
    <transition :name="transitionName">
      <router-view/>
    </transition>
    <Vfooter />
  </div>
</template>
<script>
import Header from './components/vheader'
import Vfooter from './components/vfooter'
import { VERSION, BUILD_VERSION } from '../version'
export default {
    name:'app',
    data(){
      return{
        transitionName:''
      }
    },
    components:{
      Header,
      Vfooter
    },
    watch: {
      '$route' (to, from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'fold-right' : 'fold-left'
      },
    },
    mounted() {
      const versionInfo = `当前版本: ${VERSION} \n开发时间: ${BUILD_VERSION} `
      console.info(versionInfo);
    }
  }
</script>
<style lang="less">

 @import "assets/style/common.less";
 @font-face {
    font-family: "HKGrotesk-Light";
    src: url("../src/assets/font/HK-Grotesk/HKGrotesk-Light-5.otf");
  }
  @font-face {
    font-family: "HKGrotesk-Medium";
    src: url("../src/assets/font/HK-Grotesk/HKGrotesk-Medium-7.otf");
  }
  @font-face {
    font-family: "HKGrotesk-Bold";
    src: url("../src/assets/font/HK-Grotesk/HKGrotesk-Bold-2.otf");
  }
  @font-face {
    font-family: "HKGrotesk-Regular";
    src: url("../src/assets/font/HK-Grotesk/HKGrotesk-Regular-9.otf");
  }
  @font-face {
    font-family: "HKGrotesk-SemiBold";
    src: url("../src/assets/font/HK-Grotesk/HKGrotesk-SemiBold-10.otf");
  }
  html, body, div, span, p, a, img, ul, li, form, label, table, tbody, tfoot, thead, tr, th, td{
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
    min-width: 1200px;
  }
  ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  button{
    outline:none;
  }


</style>
